
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="类型">
              <a-select
                      showSearch
                      optionFilterProp="title"
                      v-model="queryParam.clubleixing"
                      placeholder="类型"
                      allowClear
              >
                <a-select-option   title="考级中心" value="学校俱乐部">学校俱乐部</a-select-option>
                <a-select-option   title="社会俱乐部" value="社会俱乐部">社会俱乐部</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属地区">
              <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="授牌赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="升级赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq2" changeOnSelect/>
            </a-form-item>
          </a-col> -->
         <a-col :md="6" :sm="24">
           <a-form-item label="进度">
             <a-select v-model="queryParam.grade_status" placeholder="请选择"
                       allowClear >
               <a-select-option value="1">等待审核</a-select-option>
               <a-select-option value="2">审核成功</a-select-option>
               <a-select-option value="3">审核失败</a-select-option> 
             </a-select>
           </a-form-item>
         </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="负责人姓名">
                <a-input v-model="queryParam.nickname" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="联系电话">
              <a-input v-model="queryParam.phone" placeholder="联系电话"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="申报时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>
 </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <!-- <a-button @click="download(2)" style="margin-left: 8px">
        下载信息表
        <a-icon type="download" />
      </a-button> -->
<!--      <a-dropdown v-if="  selectedRowKeys.length > 0">-->
<!--        <a-menu slot="overlay">-->
<!--          &lt;!&ndash;          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>&ndash;&gt;-->
<!--          <a-menu-item @click="onClubDeleteAll" key="1"><a-icon type="delete" />删除</a-menu-item>-->
<!--        </a-menu>-->
<!--        <a-button style="margin-left: 8px">-->
<!--          批量操作 <a-icon type="down" />-->
<!--        </a-button>-->
<!--      </a-dropdown>-->
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <img style="width: 38px ; height: 38px; float: left" :src="record.pic_url" />
          <div style="margin-left: 10px; float: left">
<!--            {{record.danwei}}-->
            {{record.shenbaodanwei}}
            <a-tag v-if="record.clubleixing=='学校俱乐部'" color="green">
              学校俱乐部
            </a-tag>
            <a-tag v-else color="blue">
              社会俱乐部
            </a-tag>

            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            负责人:{{record.nickname}} <span style="color: #999">手机:{{record.phone}}</span>
            <br/>
            联系人:{{record.contactsname}} <span style="color: #999">手机:{{record.contactsphone}}</span>
            <br/> 
            升级等级:
            <a-tag  >{{record.bgrade}}</a-tag>
<br/>
        管理员备注:{{record.admin_note}} <br/>
        拒绝理由:{{record.refuse_note}} <br/>
          </div>
      </span>
      <span slot="grade_bgrade" slot-scope="text,record">
        {{record.grade_bgrade}}
        <br/>
        申请时间 {{record.create_time_grade|timeFormat}}
      </span>
      <span slot="code" slot-scope="text,record">
            {{record.bcode?record.bcode:'(无)'}}
            <br/>
        <span v-if="record.recommend_name" >推荐加盟人：{{record.recommend_name}}</span> 

      </span>
      <span slot="jindu" slot-scope="text,record">

        <a-tag v-if="record.grade_status==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.grade_status==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.grade_status==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template > 
         <a @click="handleEdit(record)">编辑</a>
<!--          <a-divider type="vertical" />-->
<!--          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">-->
<!--            <a href="javascript:;">删除</a>-->
<!--          </a-popconfirm>-->
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >  
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="验收表上传"
                      hasFeedback
              >
                <pic-uploader
                        :file-list="formData.yanshoubiao_pic"
                />
              </a-form-item>
            </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="审核"
                  hasFeedback
          >
            <a-radio-group v-model="formData.status" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
              <a-radio-button :value="1">待审核</a-radio-button>
              <a-radio-button :value="2">审核通过</a-radio-button>
              <a-radio-button :value="3">审核失败</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>

 


          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="拒绝审核理由"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'refuse_note',
          {rules: []}
        ]"
                        placeholder="请拒绝审核理由"/>
          </a-form-item>
</a-col>
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="管理员备注"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'admin_note',
          {rules: []}
        ]"
                        placeholder="管理员备注"/>
          </a-form-item>
</a-col>
            </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import setting from "@/config/setting";
  import qs from "qs";
  
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

import { 
  sjsqOptions, 
} from '@/api/sai'
  import { clubGradeJiansheList ,getClubDetail,editClub, clubDeleteAll,deleteClub,editClubJianshe ,clubJiansheDetail,editClubGradeNote} from '@/api/club'
  import {centerDeleteAll, deleteCenter} from "@/api/qcxj";
  export default {
    name: 'ExameCenterList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
      sjsqOptions: [],
        formData:{
          id:0,
          danwei:'',
          changdipic:[],
          namekeys:[],
          areas:[],
          zhizhaopic:[],
          shenbaozip:[],
          yanshou_pic:[],
          yanshoubiao_pic:[],
          xflag:[],
          is_tequan:2,
        },
        buyGoodsOptions:[
          {
            "label":"1 标准肋木",
            "value":1
          },
          {
            "label":"2 标准把杆（固定/移动）",
            "value":2
          },
          {
            "label":"3 斜坡啦啦操垫（翻滚）",
            "value":4
          },
          {
            "label":"4 啦啦操训练垫",
            "value":8
          },
          {
            "label":"5 柔韧测试器（髋部）",
            "value":16
          },
          {
            "label":"6 积木式跳箱",
            "value":32
          },
          {
            "label":"7 柔韧测试器（肩部）",
            "value":64
          },
          {
            "label":"8 啦啦操翻腾训练辅助器（组合）A",
            "value":128
          },
          {
            "label":"9 啦啦操翻腾训练辅助器（组合）B",
            "value":256
          },
          {
            "label":"10 七彩星级专用训练考试地胶",
            "value":512
          },
          {
            "label":"11 啦啦操方形蹦床",
            "value":1024
          },
          {
            "label":"12啦啦操专用平衡器",
            "value":2048
          }
        ],
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'grade_id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          // {
          //   title: '授权编号',
          //   dataIndex: 'code',
          //   scopedSlots: { customRender: 'code' },
          // },
          {
            title: '申报星级',
            dataIndex: 'grade_bgrade',
            scopedSlots: { customRender: 'grade_bgrade' },
          },
          {
            title: '进度',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            // fixed: 'right',
            width: 120,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return clubGradeJiansheList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions() {
        let that = this;
        sjsqOptions({}).then(res => {
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        clubJiansheDetail({ id: record.grade_id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data }) 
            console.log('handleEdit') 
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
  
      deleteHandle(record) {
        let self = this
        deleteClub({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      onClubDeleteAll() {
        let self = this
        clubDeleteAll({ ids: this.selectedRowKeys }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editClubJianshe({
              id:self.formData.id, 
              yanshoubiao_pic:self.formData.yanshoubiao_pic,
              status:self.formData.status,
              admin_note:values.admin_note,
              refuse_note:values.refuse_note,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      download(){
        window.open(setting.apiBaseURL+'/adminapi/club/clubGradeDownload?'+qs.stringify(this.queryParam));
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

      sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    onNoteChange(key, dataIndex, value) {
      let self = this;
      editClubGradeNote({
        id: key,
        admin_note: value,
      })
        .then((res) => {
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

    },
    filters:{
      jinduFilter(value){
        switch (value){
          case 1:
            return `联系申报单位`;
          case 2:
            return `告知省级并征求意见+申报单位积极准备中`;
          case 3:
            return `申报单位积极准备中`;
          case 4:
            return `条件已具备，等待验收`;
          case 5:
            return `等待全国啦啦操验收`;
          case 6:
            return `验收并授牌`;
          case 7:
            return `同意考试`;
        }
      },
    },
    watch: {
    }
  }
</script>
